window.customElements.define("mobile-menu", class MobileMenu extends HTMLElement {

  constructor() {

    super();

    this.isVisible = false;
    this.transitionTime = 300;
    this.animationStyle = null;
    this.mobilemenuEl = null;
    this.pageWrapEl = null;
    this.isHiddenClass = 'mobilemenu--hidden';
    this.isVisibleClass = 'mobilemenu--isVisible';
    this.isActiveClass = 'active';
    this.dropdownListTarget = '.mobilemenu__link[aria-expanded]';
    this.dropdownExpandedListTarget = '.mobilemenu__link[aria-expanded="true"]';
    this.tierActiveTarget = 'mobile-menu-tier.' + this.isActiveClass;
    this.linkTarget = '.mobilemenu__link';
    this.mobilemenuToggleTarget = '[data-mobilemenu="toggle"]';
    this.mobilemenuCloseTarget = '.mobile-menu-button-close,mobile-menu-curtain';
    this.header = document.querySelector('.section-header');
    this.annoucementBar = document.querySelector('.announcement-bar-section');
    this.lastTriggerEl = null;
    this.handleDocumentKeydownBound = this.handleDocumentKeydown.bind(this);
  }

  connectedCallback() {
    this.mobilemenuAddCurtain();
    this.mobilemenuEl = this.querySelector('aside');
    this.pageWrapEl = document.querySelector('.mobile-menu-page');
    this.setMobilemenuAnimationStyle();
    this.setMobilemenu();

    if (this.mobilemenuEl) {
      this.setPanelHiddenState(true);
    }
    this.updateToggleButtonsExpanded(false);

    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i=0;i<toggleButtons.length;i++) {
      toggleButtons[i].addEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    // Event Listeners
    this.addEventListener('click',this.mobilemenuCloseEventClick.bind(this));
    this.addEventListener('click',this.dropdownListEventClick.bind(this));
    this.addEventListener('click',this.backButtonEventClick.bind(this));
    //this.addEventListener('click',this.tierLinkEventClick.bind(this));
  }

  disconnectedCallback() {

    // Remove classes
    this.pageWrapEl.classList.remove('active');
    this.pageWrapEl.classList.remove('mobilemenu--push-left');
    this.pageWrapEl.classList.remove('mobilemenu--push-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-left');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-bottom');

    // Remove eventListeners
    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i=0;i<toggleButtons.length;i++) {
      toggleButtons[i].removeEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    this.removeEventListener('click',this.mobilemenuCloseEventClick.bind(this));
    this.removeEventListener('click',this.dropdownListEventClick.bind(this));
    this.removeEventListener('click',this.backButtonEventClick.bind(this));
    //this.removeEventListener('click',this.tierLinkEventClick.bind(this));

    document.removeEventListener('keydown', this.handleDocumentKeydownBound);

    // Reset properties
    this.animationStyle = null;
  }

  // Methods
  mobilemenuHide() {
    this.setPanelHiddenState(true);
    this.updateToggleButtonsExpanded(false);
    this.classList.remove(this.isVisibleClass);
    this.pageWrapEl.classList.remove(this.isActiveClass);
    this.isVisible = false;
    document.removeEventListener('keydown', this.handleDocumentKeydownBound);

    if (this.lastTriggerEl) {
      this.lastTriggerEl.focus();
    }

    if (this.header.classList.contains('reset-z-index')) {
      this.header.classList.remove('reset-z-index');
    }
    if (this.annoucementBar.classList.contains('reset-z-index')) {
      this.annoucementBar.classList.remove('reset-z-index');
    }

    const closeMenuElement = document.querySelectorAll('.menu-drawer__menu .menu-opening .menu-drawer__close-button');

    closeMenuElement.forEach((closeMenuElement) => {
      closeMenuElement.click();
    });


  }

  mobilemenuShow() {
    this.setPanelHiddenState(false);
    this.updateToggleButtonsExpanded(true);
    this.classList.add(this.isVisibleClass);
    this.pageWrapEl.classList.add(this.isActiveClass);
    this.isVisible = true;

    const closeButton = this.mobilemenuEl.querySelector('.mobile-menu-button-close');
    const focusableEls = this.getFocusableElements();
    const closeButtonIsFocusable = closeButton && closeButton.getClientRects().length > 0 && !closeButton.disabled;
    const firstFocusableEl = closeButtonIsFocusable ? closeButton : (focusableEls[0] || this.mobilemenuEl);
    firstFocusableEl.focus();

    document.addEventListener('keydown', this.handleDocumentKeydownBound);
  }

  handleDocumentKeydown(event) {
    if (!this.isVisible) return;
    const key = event.code ? event.code.toUpperCase() : event.key;
    if (key === 'ESCAPE') {
      event.preventDefault();
      this.mobilemenuHide();
      return;
    }

    if (key === 'TAB') {
      this.trapFocusLoop(event);
    }
  }

  getFocusableElements() {
    if (!this.mobilemenuEl) return [];
    const selector = 'summary, a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.from(this.mobilemenuEl.querySelectorAll(selector)).filter((el) => {
      return !el.hasAttribute('inert') && el.getClientRects().length > 0;
    });
  }

  getPotentiallyFocusableElements() {
    if (!this.mobilemenuEl) return [];
    const selector = 'summary, a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';
    return Array.from(this.mobilemenuEl.querySelectorAll(selector));
  }

  applyHiddenFocusableFallback(isHidden) {
    const focusableElements = this.getPotentiallyFocusableElements();

    focusableElements.forEach((el) => {
      if (isHidden) {
        if (!el.hasAttribute('data-mobilemenu-prev-tabindex')) {
          const prevTabindex = el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '';
          el.setAttribute('data-mobilemenu-prev-tabindex', prevTabindex);
        }
        el.setAttribute('tabindex', '-1');
        return;
      }

      if (!el.hasAttribute('data-mobilemenu-prev-tabindex')) return;
      const prevTabindex = el.getAttribute('data-mobilemenu-prev-tabindex');
      if (prevTabindex === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', prevTabindex);
      }
      el.removeAttribute('data-mobilemenu-prev-tabindex');
    });
  }

  setPanelHiddenState(isHidden) {
    if (!this.mobilemenuEl) return;
    this.mobilemenuEl.setAttribute('data-open', isHidden ? 'false' : 'true');
    this.mobilemenuEl.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
    if (isHidden) this.mobilemenuEl.setAttribute('inert', '');
    else this.mobilemenuEl.removeAttribute('inert');

    // Fallback for environments/checkers that ignore inert on descendants.
    this.applyHiddenFocusableFallback(isHidden);
  }

  trapFocusLoop(event) {
    const focusableEls = this.getFocusableElements();
    if (focusableEls.length === 0) {
      event.preventDefault();
      this.mobilemenuEl.focus();
      return;
    }

    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    const activeEl = document.activeElement;
    const isShift = event.shiftKey;

    if (isShift && (activeEl === firstFocusableEl || activeEl === this.mobilemenuEl)) {
      event.preventDefault();
      lastFocusableEl.focus();
      return;
    }

    if (!isShift && activeEl === lastFocusableEl) {
      event.preventDefault();
      firstFocusableEl.focus();
      return;
    }

    if (!this.mobilemenuEl.contains(activeEl)) {
      event.preventDefault();
      firstFocusableEl.focus();
    }
  }

  updateToggleButtonsExpanded(isExpanded) {
    const toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }

  toggleButtonEventClick(event) {
    const trigger = event && event.currentTarget ? event.currentTarget : document.querySelector(this.mobilemenuToggleTarget);
    this.lastTriggerEl = trigger;
    this.mobilemenuToggle();
    //this.setFirstTier();
  }

  mobilemenuAddCurtain() {
    if (document.querySelector('mobile-menu-curtain')) return;
    this.innerHTML = '<mobile-menu-curtain></mobile-menu-curtain>' + this.innerHTML;
  }

  dropdownListEventClick(event) {
    if (!event.target.closest(this.dropdownListTarget)) return false;

    let dropdownListEl = event.target;
    if (dropdownListEl.getAttribute('aria-expanded') === 'false') {
      dropdownListEl.setAttribute('aria-expanded', 'true');
      return true;
    }

    dropdownListEl.setAttribute('aria-expanded', 'false');
    return true;
  }

  dropdownListCollapseAll() {
    // close all expanded dropdown lists
    let expandedDropdownListEls = this.mobilemenuEl.querySelectorAll(this.dropdownExpandedListTarget);

    setTimeout(() => {
      for (var i = 0; i < expandedDropdownListEls.length; i++) {
        expandedDropdownListEls[i].setAttribute("aria-expanded", "false");
      }
    }, this.transitionTime);
  }

  nextTier(tierEl) {
    if (!tierEl) return;

    tierEl.classList.add(this.isActiveClass);

    this.attachScrollingEventListener();
    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  previousTier() {
    var activeTiers = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    var lastActiveTier = activeTiers[(activeTiers.length - 1)];

    lastActiveTier.classList.remove(this.isActiveClass);

    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  setBackButton() {
    if (!this.mobilemenuEl) return;

    let backButton = this.mobilemenuEl.querySelector('mobile-menu-button-back');
    if (!backButton) return false;

    if (this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length === 1) {
      backButton.classList.add(this.isHiddenClass);
    }
    else {
      backButton.classList.remove(this.isHiddenClass);
    }
    return true;
  }

  backButtonEventClick(event) {
    if (!event.target.closest('mobile-menu [data-mobilemenu="back"]')) return false;

    //this.previousTier();

    return true;
  }

  unsetAllActiveTiers() {
    let activeTierEls = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    let self = this;
    setTimeout(() => {
      for (var i = 0; i < activeTierEls.length; i++) {
        let activeTierEl = activeTierEls[i];
        activeTierEl.classList.remove(self.isActiveClass);
      }
    }, this.transitionTime);
  }

  setFirstTier() {
    let tier1El = this.mobilemenuEl.querySelector('#tier-1-0-0');

    if (!tier1El) return;

    if (tier1El.classList.contains(this.isActiveClass)) {
      this.unsetAllActiveTiers();
      this.dropdownListCollapseAll();
    }
    else {
      tier1El.classList.add(this.isActiveClass);
      this.attachScrollingEventListener();
    }

    this.setBackButton();
  }

  mobilemenuToggle() {
    if (!this.mobilemenuEl) return;

    if (!this.isVisible) {
      this.mobilemenuShow();
    }
    else {
      this.mobilemenuHide();
    }
  }

  setMobilemenuAnimationStyle() {
    if (!this.mobilemenuEl) return false;

    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-left')) ? 'push-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-right')) ? 'push-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-left')) ? 'overlay-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-right')) ? 'overlay-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-bottom')) ? 'overlay-bottom' : this.animationStyle;
  }

  isAnimationStylePush() {
    return (this.animationStyle === 'push-left' || this.animationStyle === 'push-right');
  }

  setMobilemenu() {
    if (!this.mobilemenuEl) return false;

    if (!this.pageWrapEl) {
      console.log('Fostr MobileMenu: Please add the page wrap.');
      return;
    }

    this.pageWrapEl.classList.add('mobilemenu--' + this.animationStyle);
    this.classList.add('mobilemenu--' + this.animationStyle);

    return true;
  }

  // Event handlers
  tierLinkEventClick(event) {
    if (!event.target.closest(this.linkTarget)) return false;

    if (event.target.tagName === 'A') return;

    let linkEl = event.target;
    if (linkEl.nextElementSibling) return true;

    let nextTierEl = this.mobilemenuEl.querySelector('#' + linkEl.id.replace('-link', ''));
    if (!nextTierEl) return true;

    this.nextTier(nextTierEl);

    return true;
  }

  mobilemenuCloseEventClick(event) {
    if (!event.target.closest(this.mobilemenuCloseTarget)) return false;

    this.mobilemenuHide();
  }

  attachScrollingEventListener() {
    if (!this.mobilemenuEl) return;

    let lastActiveTierEl = this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)')[this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)').length - 1];
    if (!lastActiveTierEl) return;

    let lastActiveTierBodyEl = lastActiveTierEl.querySelector('mobile-menu-tier-body');
    if (!lastActiveTierBodyEl) return;

    lastActiveTierBodyEl.addEventListener('scroll',() => {
      if (!lastActiveTierBodyEl) return;

      if (lastActiveTierBodyEl.scrollTop > 0) {
        lastActiveTierEl.classList.add('mobilemenu--scrolling');
      }
      else {
        lastActiveTierEl.classList.remove('mobilemenu--scrolling');
      }
    }, {
      passive: true
    });

    lastActiveTierEl.classList.add('mobilemenu--watchingScroll');
  }
})